import angular from 'angular';
import GenderGroupComponent from './gender-group.component';

const genderGroup = angular
	.module('genderGroup', [])
	.component('genderGroup', GenderGroupComponent)
	.name;

export default genderGroup;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/gender-group/gender-group.module.js